module.exports = __webpack_public_path__ + "static/img/sdzb.23b992e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/sdzb.png
// module id = H1NQ
// module chunks = 0